import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { fetchMunicipalities } from '../../project/project-tva-bosse-samleside/project-tva-bosse-actions';
import { getPopulationForMunicipalityCode } from '../../utils/location/location-utils';

const compareMunicipality = (a, b) => {
    return b.gjennomsnitt - a.gjennomsnitt;
};

export const useToppKommuner = () => {
    const tvaEventId = useSelector((state) => state.campaigns.tvaEventId);
    const p3aEventId = useSelector((state) => state.campaigns.p3aEventId);
    const baseUrl = useSelector((state) => state.baseURL);

    const [isLoading, setIsLoading] = useState(false);
    const [hasFailed, setHasFailed] = useState(false);
    const [toppKommuner, setToppKommuner] = useState([]);

    async function fetchData() {
        try {
            setIsLoading(true);
            const resultRaw = await fetchMunicipalities({
                eventIds: [tvaEventId, p3aEventId].filter((id) => !!id),
                baseUrl,
            });
            const result = await resultRaw.json();
            const topMunicipalities = result?.aggregationResults?.group_by_municipality ?? [];

            setIsLoading(false);
            setToppKommuner(
                topMunicipalities
                    .map((munic) => ({
                        navn: munic.key[0],
                        antallBosser: munic.count,
                        sum: munic.sum,
                        gjennomsnitt:
                            munic.sum /
                            getPopulationForMunicipalityCode({
                                municipalityCode: munic.key[2],
                            }),
                        fylke: munic.key[1],
                    }))
                    .sort(compareMunicipality)
            );
        } catch (e) {
            setIsLoading(false);
            setHasFailed(true);
        }
    }

    useEffect(() => {
        fetchData();
    }, [tvaEventId, p3aEventId, baseUrl]);

    return {
        isLoading,
        hasFailed,
        toppKommuner,
    };
};
